interface ZusLogoIconOnlyProps {
  width: number;
  height: number;
}
export const ZusLogoIconOnly = ({ width = 35, height = 35 }: ZusLogoIconOnlyProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 644 584"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Zus Logo</title>
    <path
      d="M343.387 0C390.996 0.000181547 433.839 28.9233 451.635 73.0889L515.107 230.643C517.558 236.723 523.453 240.704 530.019 240.704H627.295C640.015 240.704 647.687 254.768 640.821 265.46L470.683 530.362C449.215 563.784 412.216 584.001 372.497 584.001H300.006C252.397 584.001 209.555 555.067 191.758 510.901L128.287 353.348C125.836 347.267 119.941 343.286 113.374 343.286H16.0981C3.38926 343.286 -4.29359 329.222 2.57272 318.529L172.701 53.6377C194.179 20.206 231.168 9.95191e-05 270.897 0H343.387ZM323.015 105.519C318.124 93.368 301.537 91.8581 294.526 102.923L166.01 305.945H166.02C159.247 316.648 166.941 330.607 179.598 330.607H249.988C256.544 330.607 262.449 334.589 264.9 340.68L320.378 478.472C325.27 490.622 341.857 492.132 348.868 481.067L477.374 278.045C484.146 267.342 476.463 253.382 463.795 253.382H393.406C386.85 253.382 380.944 249.401 378.494 243.311L323.015 105.519Z"
      fill="#009688"
    />
  </svg>
);
